
import 'components/autocomplete.tag'
import 'components/datetime-picker.tag'
import 'pages/products/modifications/modifications-list-modal.tag'
import 'components/loader.tag'
import 'components/catalog.tag'
riot.tag2('purchases-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#purchases"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;purchases&quot;, &quot;0100&quot;) : checkPermission(&quot;purchases&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новая закупка\' : \'Редактирование закупки № \' + item.id}</div>\n    <div class="tab-content-purchase">\n      <div id="purchase-edit-home">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-1" if="{!isNew}">\n              <div class="form-group">\n                <label class="control-label">Ид</label>\n                <input class="form-control" name="id" value="{item.id}" readonly>\n              </div>\n            </div>\n            <div class="col-md-2">\n              <div class="form-group">\n                <label class="control-label">Дата закупки</label>\n                <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}" icon="glyphicon glyphicon-calendar" onchange="{purchaseDateChange}"></datetime-picker>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Поставщик</label>\n                <input class="form-control" name="provider" value="{item.provider}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <div class="h4">Платежи</div>\n                <catalog-static name="payments" rows="{item.payments}" cols="{paymentsCols}" remove="{item.status!=&quot;N&quot;}" handlers="{itemsHandlers}" responsive="false" limit="999">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{parent.item.status!=&quot;N&quot;}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addPayment}"><i class="fa fa-plus"></i> Добавить платеж</button>\n                    </div>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="pos" style="width:100px;">{parent.i + 1}</datatable-cell>\n                    <datatable-cell name="date" style="width:150px;">\n                      <datetime-picker class="form-control" format="YYYY-MM-DD" value="{row.date}" icon="glyphicon glyphicon-calendar" onchange="{handlers.stringChange}"></datetime-picker>\n                    </datatable-cell>\n                    <datatable-cell name="amount" style="width:150px;">\n                      <input class="form-control" value="{row.amount}" step="1" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="commentary">\n                      <input class="form-control" value="{row.commentary}" type="text" onchange="{handlers.stringChange}">\n                    </datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="row">\n                  <div class="col-md-12">\n                    <div class="pull-right">\n                      <label>Итого:</label><strong> {amountPayments}</strong>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove="{item.status!=&quot;N&quot;}" handlers="{itemsHandlers}" limit="999">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{parent.item.status!=&quot;N&quot;}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addProducts}"><i class="fa fa-plus"></i> Добавить товар</button>\n                    </div><span class="pull-right"><strong class="text-muted pull-left">Курс EUR: {parent.item.courses.eur}</strong></span>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="pos">{parent.i + 1}</datatable-cell>\n                    <datatable-cell name="nameBrand">{row.nameBrand}</datatable-cell>\n                    <datatable-cell name="name" style="width: 50%;">\n                      <input value="{row.name}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="count" style="max-width: 20px;">\n                      <input value="{row.count}" step="1" min="1" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="priceEuro" style="max-width: 50px;">\n                      <input value="{row.priceEuro}" step="0.01" min="0" oninput="{handlers.numberChange}" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="price" style="max-width: 50px;">\n                      <input class="{text-muted: (row.priceEuro &gt; 0)}" value="{row.price}" __readonly="{row.priceEuro &gt; 0}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="discount" style="max-width: 20px;">\n                      <input value="{row.discount}" step="0.01" min="0" max="100" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="amount" style="max-width: 20px;">{(row.count * (row.price * (1 - row.discount/100))).toFixed(0).toLocaleString()}</datatable-cell>\n                    <datatable-cell name="markup" style="min-width: 60px;">\n                      <input value="{row.markup}" step="0.01" min="0" max="100" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell name="sellingPrice" onclick="{handlers.copyText}">{(row.count * (row.price  * (1 - row.discount/100)) * (row.markup > 0 ? row.markup: 0) ).toFixed(0).toLocaleString()}</datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="alert alert-danger" if="{error.items}">{error.items}</div>\n                <div class="row">\n                  <div class="col-md-12">\n                    <div class="pull-right">\n                      <label>Сумма закупки:</label><strong> {sumProductsDisplay}</strong><br>\n                      <label>Сумма продажи:</label><strong>{sellngTotalDisplay}</strong>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Комментарий</label>\n                <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this,
    route = riot.route.create();

self.isNew = false;
self.item = {};
self.items = [];
self.loader = false;
self.sumProducts = 0;
self.sellingTotal = 0;
self.amountPayments = 0;
self.total = 0;
self.pos = 1;
self.snd = true;

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.send = function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "send" }));

    self.snd = !self.snd;
    self.update();
};

self.rules = function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "rules" }));

    var rules = {
        items: {
            required: true,
            rules: [{
                type: 'minLength[1]',
                prompt: 'В списке должно быть не менее одного элемента'
            }]
        }
    };
};

self.afterChange = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
};

self.dynFieldsChange = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dynFieldsChange" }));
    var type = e.item.field.type;

    if (type !== 'checkbox') {
        e.item.field.value = e.target.value;
    } else {
        var checkedValues = (e.item.field.value || '').split(',');
        var checkedValue = e.target.getAttribute('data-value');
        var idx = checkedValues.indexOf(checkedValue);

        if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);

        e.item.field.value = checkedValues.filter(function (i) {
            return i;
        }).join(',');
    }
};

self.itemsCols = [{ name: 'num', value: '#' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'Кол-во' }, { name: 'priceEuro', value: 'Цена EUR' }, { name: 'price', value: 'Цена RUB' }, { name: 'discount', value: 'Скидка, %' }, { name: 'amount', value: 'Сумма' }, { name: 'markup', value: 'Кэф.' }, { name: 'sellingPrice', value: 'Цена продажи' }];

self.paymentsCols = [{ name: 'num', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'amount', value: 'Сумма' }, { name: 'commentary', value: 'Комментарий' }];

self.displayFormat = function (price) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "displayFormat" }));

    if (self.currPrefix != null) return self.currPrefix + ' ' + price.toLocaleString();
    if (self.currSuffix != null) return price.toLocaleString() + ' ' + self.currSuffix;
};

self.convertEuroPrice = function (item) {
    if (!item || item.priceEuro === '' || item.priceEuro === null || typeof item.priceEuro === 'undefined') return;

    var priceEuro = parseFloat(item.priceEuro);
    if ((0, _isNan2.default)(priceEuro)) return;

    API.request({
        object: 'Currency',
        method: 'CONVERT',
        data: {
            price: priceEuro,
            source: 'EUR',
            target: self.item.curr || self.basecurr || 'RUB',
            rateDate: self.item.date
        },
        success: function success(response) {
            if (response && typeof response.price !== 'undefined') {
                item.price = response.price;
                if (self.tags.items) self.tags.items.update();
                self.update();
            }
        }
    });
};

self.convertEuroPrices = function () {
    if (!self.item || !self.item.items) return;

    self.item.items.forEach(function (item) {
        if (item.priceEuro !== '' && item.priceEuro !== null && typeof item.priceEuro !== 'undefined') self.convertEuroPrice(item);
    });
};

self.purchaseDateChange = function (e) {
    self.item.date = e.target.value;
    self.convertEuroPrices();
};

/** элементы Обработчики */
self.itemsHandlers = {
    numberChange: function numberChange(e) {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "numberChange" }));
        this.row[this.opts.name] = e.target.value;
        if (this.opts.name == 'priceEuro' && e.target.value > 0) {
            this.row['price'] = (self.item.courses.eur * e.target.value).toFixed(0);
        }
        //if (this.opts.name == 'priceEuro')
        //    self.convertEuroPrice(this.row)
    },
    stringChange: function stringChange(e) {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "stringChange" }));
        this.row[this.opts.name] = e.target.value;
    },
    addPayment: function addPayment() {
        self.item.payments.push({ id: null, date: new Date().toISOString().split('T')[0], amount: 0, commentary: null });
        self.update();
    },
    addProducts: function addProducts() {

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts" }));

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
            groupLog: "addProdD", dComment: ">Добавить self.item.items",
            dArray: self.item.items }));

        var purchase = self.item;
        modals.create('products-list-select-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {

                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                    groupLog: "addProdD", dComment: "submit данные добавлены",
                    dArray: self.item.items }));

                var _this = this;
                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
                self.item.items = self.item.items || [];

                if (items.length > 0) {
                    if ('countModifications' in items[0] && items[0].countModifications > 0) {
                        (function () {
                            var idPrice = items[0].id;
                            var brand = items[0].nameBrand;
                            modals.create('modifications-list-modal', {
                                type: 'modal-primary',
                                size: 'modal-lg',
                                id: idPrice,
                                submit: function submit() {
                                    var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
                                    items.forEach(function (item) {
                                        self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: 0, id: null, idPrice: idPrice, modifications: item.id, nameBrand: brand, markup: self.item.defaultMarkup }));
                                    });
                                    self.update();
                                    this.modalHide();
                                    _this.modalHide();

                                    //let event = document.createEvent('Event')
                                    //event.initEvent('change', true, true)
                                    //console.log(self.tags.items)
                                    //self.tags.items.items.root.dispatchEvent(event)
                                }
                            });
                        })();
                    } else {
                        (function () {
                            var ids = self.item.items.map(function (item) {
                                return item.id;
                            });

                            items.forEach(function (item) {
                                if (ids.indexOf(item.id) === -1) {

                                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                                        groupLog: "addProdD", dComment: "до добавления массив item",
                                        dArray: item }));

                                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                                        groupLog: "addProdD", dComment: "до добавления self.item.items",
                                        dArray: self.item.items }));

                                    self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: 0, id: null, idPrice: item.id }));
                                }
                            });

                            self.update();
                            _this.modalHide();

                            var event = document.createEvent('Event');
                            event.initEvent('change', true, true);
                            self.tags.items.root.dispatchEvent(event);
                        })();
                    }
                }

                // self.convertPrices()
            }
        });
    },
    editProduct: function editProduct(e) {

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editProduct" }));

        var oldItem = (0, _assign2.default)({}, e.item.row);
        var index = -1;
        self.item.items.forEach(function (item, i) {
            if (item.id === oldItem.id) index = i;
        });

        if (oldItem.idPrice) {

            if (oldItem["idsModifications"]) {
                modals.create('modifications-list-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    id: oldItem.idPrice,
                    submit: function submit() {
                        var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
                        if (items.length > 0) {
                            self.item.items[index] = (0, _extends3.default)({}, items[0]);
                            self.item.items[index].id = oldItem.id;
                            self.item.items[index].count = oldItem.count;
                            self.item.items[index].discount = oldItem.discount;
                            self.item.items[index].idPrice = oldItem.idPrice;
                            self.item.items[index].idsModifications = items[0].id;
                        }

                        self.update();
                        this.modalHide();

                        var event = document.createEvent('Event');
                        event.initEvent('change', true, true);
                        self.tags.items.root.dispatchEvent(event);
                    }
                });
            } else {
                var filters = {
                    field: 'id',
                    value: e.item.row.idPrice
                };
                modals.create('products-list-select-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    systemFilters: filters,
                    submit: function submit() {
                        var _this = this;
                        var items = _this.tags.catalog.tags.datatable.getSelectedRows();
                        if (items.length > 0) {
                            self.item.items[index] = (0, _extends3.default)({}, items[0]);
                            self.item.items[index].id = oldItem.id;
                            self.item.items[index].count = oldItem.count;
                            self.item.items[index].discount = oldItem.discount;
                            self.item.items[index].idPrice = oldItem.id;
                        }

                        self.update();
                        _this.modalHide();

                        var event = document.createEvent('Event');
                        event.initEvent('change', true, true);
                        self.tags.items.root.dispatchEvent(event);
                    }
                });
            }
        } else {}
    }
};

self.convertPrices = function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices" }));

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
        groupLog: "addProdD", dComment: "при конвертации self.item.items",
        dArray: self.item.items }));

    self.item.items.forEach(function (item, i) {
        if (item.curr != self.item.curr) {

            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
                groupLog: "addProdD", dComment: "конвертация item.price",
                dArray: { 'price': item.price, 'source': item.curr, 'target': self.item.curr, 'item': item } }));

            var params = { 'price': item.price, 'source': item.curr, 'target': self.item.curr };
            API.request({
                object: 'Currency',
                method: 'CONVERT',
                data: params,
                success: function success(response) {
                    item.price = response.price;
                    item.curr = self.item.curr;
                    self.update();
                }
            });
        }
    });
};

self.submit = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));

    var params = self.item;
    params.send = self.snd;

    self.error = self.validation.validate(self.item, self.rules());

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
        groupLog: "submit", dComment: "API Purchase Save", dArray: params }));

    if (!self.error) {
        API.request({
            object: 'Purchase',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                self.isNew = false;

                self.update();
                if (self.isNew) riot.route('/purchases/' + self.item.id);
                popups.create({ title: 'Успех!', text: 'Запись сохранена!', style: 'popup-success' });
                if (self.tags.catalog) self.tags.catalog.reload(); // перезагрузка каталога
                observable.trigger('purchases-reload');
            }
        });
    }
};

self.reloadButton = function () {

    /** обновление страницы карточки контакта с всплывающим предупреждением */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));

    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                self.reload();
            }
            this.modalHide();
        }
    });
};

self.reload = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
    observable.trigger('purchase-edit', self.item.id);
}; // перезагрузить

self.on('update', function () {

    if (self.item && self.item.payments) {
        self.amountPayments = self.item.payments.reduce(function (p, c) {
            return p + c.amount * 1;
        }, 0);
        self.amountPayments = self.displayFormat(self.amountPayments.toFixed(2));
    }

    if (self.item && self.item.items) {
        self.sumProducts = self.item.items.map(function (i) {
            return i.count * (i.price * (1 - i.discount / 100));
        }).reduce(function (p, c) {
            return p + c;
        }, 0);
        self.sellingTotal = self.item.items.map(function (i) {
            return i.count * (i.price * (i.markup > 0 ? i.markup : 0) * (1 - i.discount / 100));
        }).reduce(function (p, c) {
            return p + c;
        }, 0);
        if (parseFloat(self.sumProducts) > 0) self.total = parseFloat(self.sumProducts || 0) + parseFloat(self.item.deliveryPayee || 0) - parseFloat(self.item.discount || 0);else self.total = 0;
        self.totalDisplay = self.displayFormat(self.total.toFixed(2));
        self.sumProductsDisplay = self.displayFormat(self.sumProducts.toFixed(0));
        self.sellngTotalDisplay = self.displayFormat(self.sellingTotal.toFixed(0));
    }
});

self.on('mount', function () {
    riot.route.exec();
});

observable.on('purchase-new', function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchase-new" }));

    self.error = false;
    self.isNew = true;
    self.sumProducts = 0;
    self.item = {
        discount: 0,
        status: '',
        idAdmin: null
    };
    if (app.config.idUser && app.config.idUser != 'admin') self.item.idAdmin = app.config.idUser;
    self.total = 0;
    self.update();
    self.getManagers();
    self.getBaseCurrency();
});

observable.on('purchase-edit', function (id) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit" }));

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit",
        groupLog: "purchasesEdit", dComment: "self start",
        dArray: self }));

    var params = { id: id };
    params["curr"] = self.item.curr;
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.update();
    self.getManagers();

    API.request({
        object: 'Purchase',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "purchases-edit",
                groupLog: "purchasesEdit", dComment: "response", dArray: response }));
            self.item = response;
            self.loader = false;
            self.getBaseCurrency();
            self.update();
            if (self.tags.catalog && self.catalogReload) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
            self.catalogReload = true; // перезагружать каталог, только после первой прогрузки
        }
    });
});

observable.on('datacatalog', function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));

    /** получение транс-табличных данных
     *  @param {object} e именаТаблиц-массивыСтрок
     *  @return {object} observable.trigger 'datacatalog'
     */

    self.datacatalog = e;
});

self.getManagers = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers" }));
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers", groupLog: "getManagers", dComment: "self", dArray: self }));
    self.managers = [];
    API.request({
        object: 'PermissionUser',
        method: 'Fetch',
        success: function success(response) {
            self.managers = response.items;
            self.update();
        }
    });
};

self.getBaseCurrency = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getBaseCurrency" }));
    API.request({
        object: 'Main',
        method: 'Info',
        success: function success(response) {
            if (!self.item.curr) self.item.curr = response.basecurr;
            self.basecurr = response.basecurr;
            response.listCurrency.forEach(function (item) {
                if (item.name.toLowerCase() == self.item.curr.toLowerCase()) {
                    self.currSuffix = item.nameFlang;
                    self.currPrefix = item.nameFront;
                }
            });
            self.update();
        }
    });
};

self.debugParam = {
    module: "purchase-edit.tag",
    dClass: "ord-ed",
    method: "",
    dComment: "",
    groupLog: "norm",
    dArray: undefined
};
self.debuger = function () {
    var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;

    /** ДЕБАГЕР
     * 1 Запуск логов
     * 2 Настройки
     * 3 Формирование строки
     * 4 Отступ
     * 5 Очередность и отображение
     *
     * self.debuger({ ...self.debugParam, method:"allParams" })
     *
     * self.debuger({ ...self.debugParam, method:"reload",
     *                groupLog: "reload", dComment:"response", dArray: response })
     */

    // 1
    var startList = {
        norm: true,
        addProdD: false,
        submit: false,
        purchasesEdit: false,
        getManagers: false
    };

    if (startList[dp.groupLog] == true && document.domain == "localhost") {

        // 2
        var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
        var gr = true;var com = true;var met = true;var cl = true;var mod = true;

        // 3
        var groupLog = "gr: " + dp.groupLog;
        var comment = "com: " + dp.dComment;
        var method = "met: " + dp.method;
        var clas = "cl: " + dp.dClass;
        var module = "mod: " + dp.module;

        // 4
        var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
        var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
        var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
        var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
        var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;

        // 5
        var consoleLog = "|";
        if (gr == true) consoleLog += groupLog + groupLogLen;
        if (com == true) consoleLog += comment + commentLen;
        if (met == true) consoleLog += method + methodLen;
        if (cl == true) consoleLog += clas + clasLen;
        if (mod == true) consoleLog += module + modLen;

        console.warn(consoleLog);
        if (dp.dArray != undefined) console.log(dp.dArray);
    }
};
});


// WEBPACK FOOTER //
// ./pages/purchases/purchases-edit.tag